import React from 'react';

const formatCurrency = (value) => {
    if (value == null || isNaN(value)) return '$0';
    return `$${Number(value).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
};

const BankLendingSummary = ({ investorResult, borrowerResult, audience }) => {
    const result = audience === 'Investor' ? investorResult : borrowerResult;
    if (!result) {
        return <div className="text-center text-gray-500">No data available for Bank Lending.</div>;
    }

    return (
        <div className="bg-white shadow-md rounded-lg p-0 w-full">
            <h2 className="text-2xl font-bold text-center text-blue-700 mb-6">Conventional Loan/Mortgage Summary</h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-2 px-2">
                {/* Investor Summary */}
                <div className="bg-gray-50 rounded-md p-4 md:p-5">
                    <h3 className="text-blue-800 text-xl font-semibold text-center mb-4">Investor/Lender Summary</h3>
                    <div className="grid gap-y-2 text-sm" style={{ display: 'grid', gridTemplateColumns: '1fr auto' }}>
                        <div>Capital Invested:</div>
                        <div className="font-semibold">{formatCurrency(investorResult.originalLoanAmount)}</div>

                        <div>Principal Paid Over Time:</div>
                        <div className="font-semibold">{formatCurrency(borrowerResult.principal)}</div>

                        <div>Interest Paid Over Time:</div>
                        <div className="font-semibold">{formatCurrency(borrowerResult.interest)}</div>

                        <div>Final Asset Value:</div>
                        <div className="font-semibold">{formatCurrency(investorResult.finalValue)}</div>

                        <div>Exit Value :</div>
                        <div className="font-semibold">{formatCurrency(investorResult.exitValue)}</div>

                        <div>Net Cashflow (Interest Earned):</div>
                        <div className="font-semibold">{formatCurrency(investorResult.netCashflow)}</div>

                        <div>Total ROI:</div>
                        <div className="font-semibold">{investorResult.totalROI}%</div>
                      
                        <div>IRR Estimate:</div>
                        <div className="font-semibold">{investorResult.irrEstimate}%</div>


                        <div>Investment/Loan Term:</div>
                        <div className="font-semibold">{investorResult.termYears} years</div>


                    </div>
                    <p className="text-xs text-gray-600 mt-3 text-center leading-snug">
                        
                    </p>
                </div>

                {/* Entrepreneur Summary */}
                <div className="bg-purple-50 rounded-md p-4 md:p-5 flex flex-col justify-between">
                    <div>
                        <h3 className="text-purple-700 text-xl font-semibold text-center mb-4">Entrepreneur Summary</h3>
                        <div className="grid gap-y-2 text-sm" style={{ display: 'grid', gridTemplateColumns: '1fr auto' }}>
                            <div>Monthly Payment:</div>
                            <div className="font-semibold">{formatCurrency(borrowerResult.monthlyPayment)}</div>

                            <div>Principal Paid:</div>
                            <div className="font-semibold">{formatCurrency(borrowerResult.principal)}</div>

                            <div>Interest Paid:</div>
                            <div className="font-semibold">{formatCurrency(borrowerResult.interest)}</div>

                            <div>Expenses Paid:</div>
                            <div className="font-semibold">{formatCurrency(borrowerResult.totalExpenses)}</div>

                            <div>Total Paid:</div>
                            <div className="font-semibold">{formatCurrency(borrowerResult.totalPayment)}</div>

                            <div>Total Equity:</div>
                            <div className="font-semibold">{formatCurrency(borrowerResult.equityBuilt)}</div>

                            <div>Exit Value (Asset Value − Sell Cost - Expenses):</div>
                            <div className="font-semibold">{formatCurrency(borrowerResult.exitValue)}</div>

                            {/* <div>Entrepreneur ROI (Exit ÷ Total Paid):</div>
                            <div className="font-semibold">{borrowerResult.entrepreneurROI?.toFixed(2) ?? 0}%</div> */}

                            <div>Loan Term:</div>
                            <div className="font-semibold">{borrowerResult.termYears} years</div>
                        </div>
                    </div>
                    <p className="text-xs text-gray-600 mt-3 text-center leading-snug">
                        
                    </p>
                </div>

            </div>
        </div>
    );
};

export default BankLendingSummary;
